<div class="tw:w-full tw:p-0 tw:m-0">
  <div class="tw:flex tw:flex-wrap tw:p-0 tw:pb-4 tw:m-0">

    <div class="tw:w-full tw:p-0 tw:m-0">

      <ng-template #utilityBarForm>

        @if (StudentSearchClientFilter) {
          <div class="flex-row">
            <div class="flex-column">
              <label class="field__label">Client</label>
              <app-searchable-select [(ngModel)]="selectedClient" [items]="clientList"
                displayField="dropdownDisplay" placeholder="Client"
                searchPlaceholder="Search clients…"></app-searchable-select>
            </div>
            <div class="flex-column">
              <label class="field__label">Created Date From</label>
              <input type="date" class="field__control" [(ngModel)]="startDate" [ngModelOptions]="{standalone: true}"
                data-toggle="tooltip" data-placement="top" title="Please select the from date">
              </div>
              <div class="flex-column">
                <label class="field__label">Created Date To</label>
                <input type="date" class="field__control" [(ngModel)]="endDate" [ngModelOptions]="{standalone: true}"
                  data-toggle="tooltip" data-placement="top" title="Please select the to date (optional)">
                </div>
              </div>
            }

            <div class="flex-row tw:mb-4">
              <div class="flex-column">
                <input class="form-control" [placeholder]="searchPlaceholder" type="text"
                  (keydown.enter)="search()" [(ngModel)]="searchText"
                  data-toggle="tooltip" data-placement="top" [title]="studentTooltip">
                </div>
                <div class="flex-column">
                  <button class="btn btn-primary" type="button" (click)="search()">Search</button>
                </div>
              </div>

            </ng-template>

            <div class="flex-row">
              <div class="flex-column">
                @if (students.length > 0) {
                  <label class="field__checkbox"><input type="checkbox" [(ngModel)]="selectAllStudentsForSend" (change)="onAllStudentsSelected({checked: $event.target.checked})" /> Select All</label>
                }
                <app-data-table
                  [columns]="columns"
                  [data]="students"
                  [pageSize]="10"
                  [emptyMessage]="emptyMessage">
                  <ng-template appColumnCell="select" let-element>
                    <label class="field__checkbox"><input type="checkbox" [checked]="checked(element)" (change)="assignCheckbox(element, {checked: $event.target.checked})" /></label>
                  </ng-template>
                  <ng-template appColumnCell="studentName" let-element>
                    {{element.studentDetailItem.firstName}} {{element.studentDetailItem.surname}}
                  </ng-template>
                  <ng-template appColumnCell="clientName" let-element>
                    @if (element.studentPupilDetailsItem?.clientName) {
                      <span>{{element.studentPupilDetailsItem?.clientName.trim()}} ({{element.studentPupilDetailsItem?.clientId}})</span>
                    }
                  </ng-template>
                  <ng-template appColumnCell="upn" let-element>
                    {{element.studentPupilDetailsItem?.upn}}
                  </ng-template>
                  <ng-template appColumnCell="mainSubject" let-element>
                    {{element.studentPupilDetailsItem?.mainSubject}}
                  </ng-template>
                  <ng-template appColumnCell="yearGroup" let-element>
                    {{element.studentPupilDetailsItem?.yearGroup}}
                  </ng-template>
                  <ng-template appColumnCell="createdDate" let-element>
                    {{element.studentDetailItem?.createdOn | date: 'dd MMM yyyy'}}
                  </ng-template>
                </app-data-table>
              </div>
            </div>

            <div class="flex-row">
              <div class="flex-column">
                <button type="submit" class="btn-outline-primary btn tw:mx-1" (click)="emailAccessLinks()"
                style="height: 35px;">Send Links</button>
              </div>
            </div>

          </div>

        </div>
      </div>